import './styles/github-theme.css';
import './styles/main.css';
import './styles/chat.css';
import './styles/components.css';
import 'highlight.js/styles/github.css';

import { EventBus } from './utils/eventBus';
import { StorageService } from './services/storage';
import { AuthService } from './services/auth';
import { ApiService } from './services/api';
import { ThemeService } from './services/theme';
import { ImageUploadService } from './services/imageUpload';
import { ChatWindow } from './components/ChatWindow';

// Initialize services
const eventBus = new EventBus();
const storage = new StorageService(eventBus);
const auth = new AuthService();
auth.ensureAuthKey();
const api = new ApiService(auth);
const theme = new ThemeService(eventBus);
const imageUpload = new ImageUploadService(auth);

// Create root component
const chatWindow = new ChatWindow(eventBus, storage, api, theme, imageUpload);

// Mount to DOM
const root = document.getElementById('app');
if (root) {
  chatWindow.mount(root);
} else {
  console.error('Root element #app not found');
}

// Ensure there's at least one conversation
const activeConv = storage.getActiveConversation();
if (!activeConv) {
  const settings = storage.getSettings();
  storage.createConversation(settings.defaultModel);
}

// Expose for debugging (optional)
if (import.meta.env.DEV) {
  (window as any).app = {
    eventBus,
    storage,
    api,
    theme,
    chatWindow,
  };
}
